import { DatabaseChangeType } from '@databases/types/redux';

import { viewToCollabJSON } from '../../../collab/convert-to-collab';
import { YJSChangeHandler } from '../../types';

export const addSavedView: YJSChangeHandler<DatabaseChangeType.ADD_SAVED_VIEW> = ({
  ydb,
  change,
}) => {
  ydb.mutate((db) => {
    db.addView(change.view.id, viewToCollabJSON(change.view, {}));
  });
};
